export const API_URL = 'https://oadmins.italscada.com';
// export const API_URL = 'http://localhost:4000';
